import React, { forwardRef, useMemo, InputHTMLAttributes } from "react";
import clsx from "clsx";
import DatePickerInput, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { parseStringToDate } from "helpers";

import styles from "./customPickerInput.module.scss";
import "static/css/calendar.scss";

const DatePicker = <WithRange extends boolean | undefined = undefined>({
	value,
	dateFormat,
	wrapperClassName,
	popperPlacement = "bottom-start",
	...props
}: ReactDatePickerProps<never, WithRange>) => {
	const InputComponent = useMemo(
		// onKeyDown, onKeyUp are not passed
		// to be able to apply filters by "Enter"
		() =>
			forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
				({ onKeyDown, onKeyUp, ...props }, ref) => {
					return <input ref={ref} {...props} />;
				},
			),
		[],
	);

	const convertedDate = parseStringToDate(
		value,
		Array.isArray(dateFormat) ? dateFormat[0] : dateFormat,
	);

	return (
		<DatePickerInput
			{...props}
			selected={
				value && !isNaN(convertedDate.valueOf()) ? convertedDate : null
			}
			dateFormat={dateFormat}
			customInput={<InputComponent />}
			wrapperClassName={clsx(styles.customDatePicker, wrapperClassName)}
			popperPlacement={popperPlacement}
			showPopperArrow={false}
		/>
	);
};

export default DatePicker;
